import { apiClient } from './apiClient';

const getTwitchOAuth = async () => {
  return await apiClient.get('/twitch/oauth');
};

const loginTwitchUser = async (body) => {
  return await apiClient.post('/twitch/login', body);
};

const userLogin = async (body) => {
  return await apiClient.post('/login', body);
};

const validateUserToken = async () => {
  return await apiClient.post('/validate-token');
};

export const authApi = {
  getTwitchOAuth,
  loginTwitchUser,
  userLogin,
  validateUserToken
};
